/**
 * @generated SignedSource<<8c7c0037c30f3184b739a0de0ef84d0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeliveryOrderTypeEnum = "gift" | "order" | "%future added value";
export type DeliveryOrderCreateInput = {
  address: AddressInput;
  description?: string | null;
  recipientName: string;
  recipientNumber: string;
  stuff: NodeInput;
  title: string;
  type: DeliveryOrderTypeEnum;
};
export type AddressInput = {
  address: string;
  addressDetail: string;
  zipCode: string;
};
export type NodeInput = {
  id: string;
};
export type DeliveryOrderCreateDialog_deliveryOrderCreateMutation$variables = {
  input: DeliveryOrderCreateInput;
};
export type DeliveryOrderCreateDialog_deliveryOrderCreateMutation$data = {
  readonly deliveryOrderCreate: {
    readonly id: string;
  };
};
export type DeliveryOrderCreateDialog_deliveryOrderCreateMutation = {
  response: DeliveryOrderCreateDialog_deliveryOrderCreateMutation$data;
  variables: DeliveryOrderCreateDialog_deliveryOrderCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeliveryOrder",
    "kind": "LinkedField",
    "name": "deliveryOrderCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeliveryOrderCreateDialog_deliveryOrderCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeliveryOrderCreateDialog_deliveryOrderCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4085282f93f0bce6882624466e21818f",
    "id": null,
    "metadata": {},
    "name": "DeliveryOrderCreateDialog_deliveryOrderCreateMutation",
    "operationKind": "mutation",
    "text": "mutation DeliveryOrderCreateDialog_deliveryOrderCreateMutation(\n  $input: DeliveryOrderCreateInput!\n) {\n  deliveryOrderCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd56a6065c8bbba04711a879572db0e7";

export default node;
